import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../services/project.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { FileUploader } from 'ng2-file-upload';
import { CommentService } from '../services/comment.service';
import { Comment } from "../models/comment";
import { states } from "../models/states";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit {
  project: any;
  projectSubscription: Subscription;
  languages = [
    { lang: "en", label: "English" },
    { lang: "fr", label: "French" },
    { lang: "ceb", label: "Cebuano" },
    { lang: "zh", label: "Chinese (Simplified)" },
    { lang: "fil", label: "Filipino" },
    { lang: "hmn", label: "Hmong" },
    { lang: "ja", label: "Japanese" },
    { lang: "kh", label: "Khmer" },
    { lang: "ko", label: "Korean" },
    { lang: "mo", label: "Mongolian" },
    { lang: "sp", label: "Spanish" },
    { lang: "va", label: "Vietnamese" }
  ].filter(function(l) {
    return environment.langs.indexOf(l.lang) >= 0;
  });

  zipPattern = "/^(d{5}(-d{4})?|[A-Z]d[A-Z] *d[A-Z]d)$/";
  fileUploadURL = environment.api;
  snackBar: MatSnackBar;
  allowedMimeTypes: string[] = ['image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ];
  allowedFileTypes: string[] = ['jpeg', 'png', 'pdf', 'doc', 'docx' ];
  uploader: FileUploader;
  hasBaseDropZoneOver: boolean = false;
  hasAnotherDropZoneOver: boolean = false; 
  refkey = "XPXC1ERR"; 
  model = null;
  submitted = false;
  showMap = false;
  states = states;
  files = [];
  theme = null;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  public onFileSelected(e: FileList): void {            
    let badFiles = Array.from(e).filter(f => {return this.allowedMimeTypes.indexOf(f.type) == -1}).map(f=> f.name);
    
    if (badFiles.length > 0) {               
      this.translate.get('project.invalid_files', {value: badFiles.join(", ")}).subscribe((res: string) => {              
          this.snackBar.open(res, "", {
            duration: 2000,
            panelClass: ['mat-toolbar', 'mat-warn']
          });
          //=> 'hello world'
      });
    }
  }

  constructor(
    private projectService: ProjectService,
    private router: Router,
    private route: ActivatedRoute,
    private commentService: CommentService,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { 
    this.snackBar = snackbar;

    this.uploader = new FileUploader({ url: this.fileUploadURL, allowedMimeType: this.allowedMimeTypes });

    // for observing changes to the current project
    this.projectSubscription = projectService.currentProject$.subscribe(project => {
      this.project = project;
      console.log("project: ", this.project);
    });
  }

  ngOnInit() {
    this.model = new Comment(environment.databaseID, environment.projectID);
    this.theme = environment.theme;
    console.log("theme: ", this.theme);
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
  }

  handleBackTap() {
    const newRoute = `${this.route.snapshot.paramMap.get('id')}/welcome`;
    this.router.navigateByUrl(newRoute);
  }

  // submit button
  onSubmit(): void {
    this.submitted = true;
    console.log("Submission to be saved: ", this.model);
    this.commentService.createComment(this.model).subscribe(result => {
      this.refkey = result[0].response.ref_key;
      this.model.submitterId = result[0].response.submitter_id;
      console.log("New submission id: ", result[0].response.id);
      this.fileUploadURL =
        environment.api +
        "submission-file-upload?id=" +
        result[0].response.id +
        "&database_id=" +
        environment.databaseID.toString() +
        "&project_id=" +
        this.model.projectId;
      this.uploader.setOptions({ url: this.fileUploadURL });
      this.uploader.uploadAll();
      this.commentService.updateCurrentCommentResponse(result[0].response);
      const newRoute = `${this.route.snapshot.paramMap.get('id')}/confirm`;
      this.router.navigateByUrl(newRoute);
      // console.log("Submission saved: ", result);
    });
  }

  // toggle visiablility of map
  toggleMap() {
    this.showMap = !this.showMap;
  }

  // topic selection update
  onTopicUpdate(id) {
    var idx = this.model.topicIds.indexOf(id);
  }

  // map upate
  onMapUpdate(point: string): void {
    console.log("notifying of point update...");
    this.model.wktPoint = point;
  }

  // new comment
  onNewComment(): void {
    // initialize the model
    this.model = new Comment(environment.databaseID, environment.projectID);
    // this.model.comment = null;
    // this.model.topicIds = [];
    // this.model.wktPoint = null;
    this.showMap = false;
    this.uploader.clearQueue();
  }
}



// WEBPACK FOOTER //
// ./src/app/form/form.component.ts